import { render, staticRenderFns } from "./SummonTips.vue?vue&type=template&id=4ee92fc8&"
import script from "./SummonTips.vue?vue&type=script&lang=ts&"
export * from "./SummonTips.vue?vue&type=script&lang=ts&"
import style0 from "./SummonTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports